import React from "react";
import { Container, Row, Col, Button } from "reactstrap";

const SunsetBlvd3600 = () => {
  document.title = "3600 W Sunset Blvd | CurbDash";

  const backgroundStyle = {
    height: "100vh",
    background: "linear-gradient(135deg, #ffffff, #f0f0f0)", // change this to any color or gradient
  };

  const buttonStyle = {
    padding: "1rem",
    fontSize: "1.2rem",
    fontWeight: 600,
    background: "linear-gradient(135deg, #1e1e1e, #4a4a4a)", // change this to any color or gradient
    border: "none",
  };

  const handleButtonClick = (type) => {
    if (type === "Compact") {
      window.open("https://buy.stripe.com/fZu14g5o615f7wZbPJgA82h", "_blank");
    } else if (type === "SUV") {
      window.open("https://buy.stripe.com/dRm6oAaIqg092cF071gA82i", "_blank");
    } else if (type === "Oversize") {
      window.open("https://buy.stripe.com/14A14g9Em4hrcRjg5ZgA82j", "_blank");
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center" style={backgroundStyle}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={6}>
            <img
              src="/cs-logo-circle.png"
              alt="Curbstand Logo"
              style={{ width: "60%", maxWidth: 280, marginBottom: 30 }}
            />
            <h2 className="text-dark mb-5 fw-semibold" style={{ fontSize: "2rem" }}>
              3600 W Sunset Blvd.
            </h2>

            <div className="d-grid gap-3 mb-3">
              <Button style={buttonStyle} onClick={() => handleButtonClick("Compact")}>
                Pay Compact
              </Button>
            </div>
            <div className="d-grid gap-3 mb-3">
              <Button style={buttonStyle} onClick={() => handleButtonClick("SUV")}>
                Pay SUV
              </Button>
            </div>
            <div className="d-grid gap-3 mb-3">
              <Button style={buttonStyle} onClick={() => handleButtonClick("Oversize")}>
                Pay Oversize
              </Button>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <p className="text-muted mb-0" style={{ fontSize: 18, marginRight: 8 }}>
                Powered by
              </p>
              <a href="https://www.curbstand.com/" target="_blank" rel="noreferrer">
                <img
                  src="/cs_horizontal_logo.webp"
                  alt="Curbstand"
                  style={{ height: 28 }}
                />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SunsetBlvd3600;